import { message } from "antd";
import { client } from "../../../actions";
import { authHeader } from "../../../helpers/auth-header";

const bindTagToMeter = async (MeterId, TagId) => {
	try {
		await client.put(
			"/Meter/meter_tags",
			{
				MeterId,
				TagId,
			},
			{
				headers: authHeader(),
			}
		);
	} catch (e) {
		console.error(e);
		message.error("Не удалось изменить тег счётчику")
	}
};

export default bindTagToMeter;
